/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const PageStepMessages = defineMessages({
  title: {
    id: 'Facebook.PageStepMessages.title',
    defaultMessage: 'Connect to Facebook page'
  },
  stepOne: {
    id: 'Facebook.PageStepMessages.stepOne',
    defaultMessage:
      'On the Facebook app page, click the {addProduct} link next to {products} in the left side navigation.'
  },
  addProduct: {
    id: 'Facebook.PageStepMessages.addProduct',
    defaultMessage: 'Add Product'
  },
  products: {
    id: 'Facebook.PageStepMessages.products',
    defaultMessage: 'Products'
  },
  stepTwo: {
    id: 'Facebook.PageStepMessages.stepTwo',
    defaultMessage:
      'Under {addProductsToYourApp}, find the {messenger} tile and click {setUp}.'
  },
  addProductsToYourApp: {
    id: 'Facebook.PageStepMessages.addProductsToYourApp',
    defaultMessage: 'Add products to your app'
  },
  messenger: {
    id: 'Facebook.PageStepMessages.messenger',
    defaultMessage: 'Messenger'
  },
  setUp: {
    id: 'Facebook.PageStepMessages.setUp',
    defaultMessage: 'Set Up'
  },
  stepThree: {
    id: 'Facebook.PageStepMessages.stepThree',
    defaultMessage:
      'In the Messenger settings, scroll down to {generalTokens} and click on {connect}'
  },
  generalTokens: {
    id: 'Facebook.PageStepMessages.generalTokens',
    defaultMessage: 'General tokens'
  },
  connect: {
    id: 'Facebook.PageStepMessages.connect',
    defaultMessage: 'Connect'
  },
  stepFour: {
    id: 'Facebook.PageStepMessages.stepFour',
    defaultMessage: 'Go to {generateAccessToken} click on {generate}'
  },
  generateAccessToken: {
    id: 'Facebook.PageStepMessages.generateAccessToken',
    defaultMessage: 'Generate Access Token'
  },
  generate: {
    id: 'Facebook.PageStepMessages.generate',
    defaultMessage: 'Generate'
  },
  noteOne: {
    id: 'Facebook.PageStepMessages.noteOne',
    defaultMessage:
      'Note: If you do not already have a page for your app, click {createANewPage}. After you finish creating the page, return to the Facebook apps page and navigate back to the Messenger settings for your app. You can then select the page you created.'
  },
  createANewPage: {
    id: 'Facebook.PageStepMessages.createANewPage',
    defaultMessage: 'Create a new page'
  },
  noteTwo: {
    id: 'Facebook.PageStepMessages.noteTwo',
    defaultMessage: 'Copy the page access token and paste it here:'
  },
  pageAccessTokenPlaceholder: {
    id: 'Facebook.PageStepMessages.pageAccessTokenPlaceholder',
    defaultMessage: 'Enter page access token'
  },
  pageAccessTokenLabel: {
    id: 'Facebook.PageStepMessages.pageAccessTokenLabel',
    defaultMessage: 'Page access token'
  },
  generatedVerifyTokenNote: {
    id: 'Facebook.PageStepMessages.generatedVerifyTokenNote',
    defaultMessage:
      'The {generatedVerifyTokenLabel} field contains a generated verify token that Facebook can use to verify your webhook URL.'
  },
  generatedVerifyTokenLabel: {
    id: 'Facebook.PageStepMessages.generatedVerifyTokenLabel',
    defaultMessage: 'Generated verify token'
  },
  regenerateVerifyToken: {
    id: 'Facebook.PageStepMessages.regenerateVerifyToken',
    defaultMessage: 'Regenerate verify token'
  },
  required: {
    id: 'Facebook.PageStepMessages.required',
    defaultMessage: 'Page access token is required'
  },
  nonEmptyPageAccessToken: {
    id: 'Facebook.PageStepMessages.nonEmptyPageAccessToken',
    defaultMessage: 'Page access token cannot be empty'
  },
  notificationTitle: {
    id: 'Facebook.PageStepMessages.notificationTitle',
    defaultMessage: 'Verification token is only valid after save'
  }
});
